export default __webpack_public_path__ + "static/media/CL05.42f25f0b.mp3";